import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KR_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#KR_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KR_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#KR_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 18.22c3.203 0 5.8-2.758 5.8-6.16 0-3.4-2.597-6.158-5.8-6.158s-5.799 2.758-5.799 6.159 2.596 6.158 5.8 6.158z",
      fill: "#3D58DB"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "KR_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 10,
      y: 5,
      width: 12,
      height: 14
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 18.22c3.203 0 5.8-2.758 5.8-6.16 0-3.4-2.597-6.158-5.8-6.158s-5.799 2.758-5.799 6.159 2.596 6.158 5.8 6.158z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#KR_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.002 12.533s-.326-2.904-2.736-3.062c-2.41-.158-3.06 2.13-3.2 2.736-.14.605-.491 2.222-3.03 2.222-2.537 0-2.766-4.11-2.766-4.11V5.471h11.732v7.06z",
      fill: "#E31D1C"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.299 2.052l.915.827-4.24 4.952-.915-.827 4.24-4.952zM8.807 3.39l.915.827-4.088 4.88-.915-.827 4.088-4.88zm2.418 2.183l-.914-.828-4.1 4.917.915.828 4.1-4.917zM25.362 1.705l-.915.825 1.587 1.862.915-.824-1.587-1.863zm2.822 3.427l-.915.824 1.587 1.863.915-.824-1.587-1.863zm-6.757.081l.915-.824 1.588 1.863-.915.824-1.588-1.863zm3.736 2.601l-.916.825 1.588 1.863.915-.825-1.587-1.863zm-2.169-3.983l.915-.824 4.419 5.38-.915.825-4.419-5.38zM26.055 14.243l-.923-.828-1.6 1.87.922.828 1.6-1.87zm-2.692 3.29l-.922-.827-1.601 1.87.923.828 1.6-1.87zm4.683-1.5l.923.827-1.6 1.87-.924-.828 1.601-1.87zm-1.636 4.194l-.922-.828-1.601 1.87.923.828 1.6-1.87zm-2.444-2.25l.923.828-1.671 1.997-.923-.828 1.67-1.997zm3.665-2.5l-.923-.827-1.671 1.997.923.828 1.67-1.997zM6.406 14.89l.916-.825 4.084 4.68-.915.825-4.085-4.68zm.953 4.093l.915-.825L10 20.054l-.915.825-1.726-1.896zM4.31 16.69l-.915.826 4.106 4.743.915-.825L4.31 16.69zm.65-.538l.915-.825 1.496 1.754-.915.825-1.496-1.753z",
      fill: "#272727"
    }
  )))
), a = t;
export {
  a as default
};
